
// helper
import { getPincodeFromStorage } from 'shared/layouts/DetailsPage/components/ProductInfo/storage';
import { getOnrKeyStorage } from 'shared/layouts/Cart/helpers';
import { getEligibleVariantName } from 'shared/components/ExperimentV2/helpers';

// constant
import { EDD_AB_EXPERIMENT } from 'shared/components/EstimatedDeliveryDetails/constants';
import { buildStoreRedirectId } from 'shared/helpers/storeUrl';

// header to be send when edd is enabled, in future will remove this when backend completely moved to edd without experiment.
const EDD_HEADER = {
  'X-SERVICEABLE': true,
};
export const ONR_HEADER = { 'X-ONEREWARD': true };

const EDD_HEADER_V1 = {
  'X-SERVICEABLE_V1': true,
};

const { isEligible: isEligibleForEDD } = getEligibleVariantName(EDD_AB_EXPERIMENT);

export const getEddHeader = () => {
  return isEligibleForEDD ? EDD_HEADER_V1 : EDD_HEADER;
};

// this is to get pincode, for desktop this will return null
export const getPincode = () => {
  // return this pincode from local storage only if edd enabled
  return getPincodeFromStorage() || undefined;
};

export const getONRHeader = () => {
  const isEligible = getOnrKeyStorage();
  return isEligible ? ONR_HEADER : {};
};

export const getMulticouponHeader = (isMulticoupon: boolean): Record<string, string> => {
  return isMulticoupon ? { experiment: 'multicoupon:true' } : {};
};

export const getTrackingParam = (store: string | null = buildStoreRedirectId()) => {
  try {
    return {
      site_navigation: window.sessionStorage.getItem('siteNavigation') || '',
      site_sub_navigation: window.sessionStorage.getItem('siteSubNavigation') || '',
      store,
    };
  } catch (err) {
    return {
      site_navigation: '',
      site_sub_navigation: '',
    };
  }
};
